import React from 'react';
import Hero from '../components/Home/Hero';
import About from '../components/Home/About';
import Services from '../components/Home/Services';
import Locations from '../components/Home/Locations';
import Testimonials from '../components/Home/Testimonials';
import Contact from '../components/Home/Contact';
import BlogPreview from '../components/Home/BlogPreview';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Locations />
      <Testimonials />
      <BlogPreview />
      <Contact />
    </>
  );
};

export default Home; 